import React from 'react';

import { colors } from '@/assets/styles/colors';
import { useTranslation } from '@/i18n';
import { Card } from '@/components/ui/cards';
import { Text } from '@/components/ui/text/Text';
import { Table } from '@/components/ui/tables/Table';
import { Skeleton } from '@/components/ui/loading';
import type { RecalculationProcessStatus } from '@/api/domains/recalculation';
import { useLastProcessTable } from '@/hooks/attendance/recalculation/useLastProcessTable';


interface LastProcessSectionProps {
  processStatus: RecalculationProcessStatus | null;
  isLoading?: boolean;
}

export const LastProcessSection: React.FC<LastProcessSectionProps> = ({
  processStatus,
  isLoading = false,
}) => {
  const { t: translate } = useTranslation();
  const { columns, actions, tableData } = useLastProcessTable(processStatus);

  return (
    <Card data-testid="last-process-section">
      <div className="flex flex-col gap-4 p-2">
        <Text variant="body-title-medium" color={colors.primary.main}>
          {translate('attendance:recalculo.ultimoProceso.title')}
        </Text>
        {isLoading && !processStatus ? (
          <Skeleton data-testid="last-process-skeleton" className="h-24 w-full" />
        ) : (
          <Table
            columns={columns}
            actions={actions}
            data={tableData}
            totalRows={tableData.length}
            hideTotalRows
            isLoading={isLoading}
            data-testid="last-process-table"
          />
        )}
      </div>
    </Card>
  );
};

export default LastProcessSection;
